import { type ClipAndBoardListItem } from '@air/api/types';

import { type KanbanColumnApiData } from '~/types/KanbanData';

export const combinePaginatedColumnData = (data: KanbanColumnApiData[] | undefined) => {
  if (!data) return undefined;
  return data.reduce<ClipAndBoardListItem[]>((combined, arr) => combined.concat(arr.data), []);
};
